import React from 'react';
import { Section } from './ui/Section';
import { Plus } from 'lucide-react';
const faqs = [{
  question: '¿Y si no tengo tiempo?',
  answer: 'Este sistema se adapta a tu ritmo, con microhábitos que puedes aplicar en minutos al día. No necesitas horas libres, solo la intención de mejorar.'
}, {
  question: '¿Qué pasa si fallo?',
  answer: 'No se trata de perfección, sino de volver al sistema una y otra vez. El Sistema Anticaos™ está diseñado específicamente para manejar las caídas y convertirlas en parte del proceso.'
}];
export function ObjectionsSection() {
  return <Section className="bg-transparent" data-id="element-159">
      <div className="text-center mb-16" data-id="element-160">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 drop-shadow-[0_2px_10px_rgba(0,0,0,0.8)]" data-id="element-161">
          Preguntas Frecuentes
        </h2>
        <p className="text-gray-200 drop-shadow-[0_1px_5px_rgba(0,0,0,0.8)]" data-id="element-162">
          Todo lo que necesitas saber antes de empezar.
        </p>
      </div>

      <div className="max-w-3xl mx-auto space-y-6" data-id="element-163">
        {faqs.map((faq, index) => <div key={index} className="bg-black/50 backdrop-blur-md border border-[#D4AF37]/20 rounded-xl p-6 md:p-8 shadow-xl" data-id="element-164">
            <h3 className="text-xl font-bold text-white mb-3 flex items-start gap-3 drop-shadow-[0_1px_3px_rgba(0,0,0,0.8)]" data-id="element-165">
              <span className="text-[#D4AF37] mt-1" data-id="element-166">
                <Plus className="w-5 h-5" data-id="element-167" />
              </span>
              {faq.question}
            </h3>
            <p className="text-gray-200 pl-8 leading-relaxed" data-id="element-168">{faq.answer}</p>
          </div>)}
      </div>
    </Section>;
}